import axios from "axios";

const options = {
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
  },
};

export const TrendingMovies = async () => {
  try {
    const { data } = await axios.get(
      "https://api.themoviedb.org/3/trending/all/day?language=en-US&page=1",
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const nowPlayingMovies = async () => {
  try {
    const { data } = await axios.get(
      "https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1",
      options
    );
    return data;
  } catch (error) {
    console.error("Error", error);
  }
};

export const MovieDetailsAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${id}`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const MovieTrailerAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${id}/videos`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const MovieCastAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${id}/credits`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const MovieSimilarAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${id}/similar`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const RecommendedMovieAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${id}/recommendations`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const MovieReviewsAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${id}/reviews`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const allMoviesAPI = async (value) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/popular?page=${value}`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const nowPlayingTvShows = async () => {
  try {
    const { data } = await axios.get(
      "https://api.themoviedb.org/3/trending/tv/week",
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const allSeriesAPI = async (value) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/top_rated`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

// Tv Shows

export const TvShowsDetailsAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/${id}`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const TvShowsTrailerAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/${id}/videos`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const TvShowsCastAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/${id}/credits`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const TvShowsSimilarAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/${id}/similar`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const RecommendedTvShowsAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/${id}/recommendations`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const TvShowsReviewsAPI = async (id) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/${id}/reviews`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const allSeasonAPI = async (id, season_number) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/${id}/season/${season_number}`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const EpisodeDetailsAPI = async (id, season_number, episode_number) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/${id}/season/${season_number}/episode/${episode_number}`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const SearchMovie = async (searchTerm) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/search/movie?query=${searchTerm}`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const SearchTvShows = async (searchTerm) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/search/tv?query=${searchTerm}`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

// Genres API
export const getMovieGenres = async () => {
  try {
    const { data } = await axios.get(
      "https://api.themoviedb.org/3/genre/movie/list?language=en",
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getTvGenres = async () => {
  try {
    const { data } = await axios.get(
      "https://api.themoviedb.org/3/genre/tv/list?language=en",
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getMoviesByGenre = async (genreId, page = 1) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/discover/movie?with_genres=${genreId}&page=${page}&sort_by=popularity.desc`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getTvShowsByGenre = async (genreId, page = 1) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/discover/tv?with_genres=${genreId}&page=${page}&sort_by=popularity.desc`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

// Anime API - Filter by Animation genre (16) for TV shows
export const getAnimeShows = async (page = 1) => {
  try {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/discover/tv?with_genres=16&with_origin_country=JP&page=${page}&sort_by=popularity.desc`,
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getTrendingAnime = async () => {
  try {
    const { data } = await axios.get(
      "https://api.themoviedb.org/3/discover/tv?with_genres=16&with_origin_country=JP&sort_by=popularity.desc&page=1",
      options
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};